import { render, staticRenderFns } from "./medicion-ficha-ver.vue?vue&type=template&id=6398b817&"
import script from "./medicion-ficha-ver.vue?vue&type=script&lang=js&"
export * from "./medicion-ficha-ver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports